import Moment from 'moment';

const parseApiDate = value => {
  if (!value) {
    return null;
  }

  const moment = Moment(value.replace(/'/g, ''), 'YYYY-MM-DD hh:mm:ss');
  if (!moment.isValid) {
    return null;
  }

  return moment.toDate();
};

export default parseApiDate;
